._container_nifuj_1 {
  max-width: 296px;
  display: inline-flex;
  white-space: nowrap;
  overflow: hidden; }

._name_nifuj_7 {
  text-overflow: ellipsis;
  overflow: hidden; }
